/**
 * This is the rows reorderable mixin for DFGrid
 */
import locale from "common/managers/locale";
import "common/bindings/field";
import reorder from "common/helper/reorder";

export default {
    /**
     * Modify the grid options to support a row re-orderable feature
     * @param column
     * @param options
     * @private
     */
    _configRowsReorderable: function(column, options) {

        if (column) {
            this.rowsReorderable = column;

            if (!options.columns) {
                options.columns = [];
            }


            options.columns.unshift({
                field: column,
                title: ' ',
                command: {
                    name: "drag",
                    text: "g",
                    className: "DFGridDragButton"
                },
                headerAttributes: {
                    "class": "DFGridDragHeader"
                },
                width: "25px"
            });
        }
    },

    disableRowsReorderable: function(val) {
        this.options.disableReorderable = val ? true : false;
        this.element.toggleClass("reorderDisabled", this.options.disableReorderable);
    },

    /**
     * Modify the datasource to support
     * @private
     */
    _prepareRowsReorderable: function() {
        if (this.rowsReorderable) {

            this.element.addClass("reorderable");
        }
    },

    /**
     * Programatically move a row to a specific position
     * @param fromTR
     * @param toIndex
     */
    reorderRow: function(fromTR, toIndex) {
        var me = this;

        // Special handling for dropping at the top; otherwise generic method handles it
        if (toIndex == 0) {
            me._adjustToTop(fromTR);
        } else {
            var toTR = me.tbody.find("tr").get(toIndex - 1);
            me._dropped(fromTR, toTR);
        }
    },

    /**
     * Programatically adjust the row position by an amount.
     * @param row Row to move
     * @param adjust 1 or -1
     */
    adjustRowPosition: function(row, adjust) {
        var now = this._getIndexFromTR(row) + 1;
        var max = this.tbody.find("tr").length;
        //now ranges from [1, Max]
        var to;
        if (adjust == 1) {
            to = now + 1;
        } else if (adjust == -1) {
            // -2 is correct, need to move to before where it should end up. Reorder indexing is crazy
            to = now - 2;
        }
        if (to >= 0 && to <= this.tbody.find("tr").length) {
            this.reorderRow(row, to);
        }
    },

    _adjustToTop: function(fromTR) {
        var me = this,
            column = me.rowsReorderable;

        var row = me.dataItem(fromTR);
        var rowIndex = me._getIndexFromTR(fromTR);
        var to = me._getRowFromIndex(0).get(column);
        me._adjust(0, rowIndex - 1, 1);
        this._setReorderPosition(row, to);
        me._changed();
    },

    _dropped: function(fromTR, toTR) {
        var me = this,
            column = me.rowsReorderable,
            base = me.options.reorderableRowsBase || 0;

        var from = me.dataItem(fromTR);
        var to = me.dataItem(toTR);
        var fromIndex = from.get(column);
        var toIndex = to.get(column);

        var setFromTo;
        if (fromIndex == toIndex) {
            return;
        } else if (fromIndex > toIndex) {
            setFromTo = to.get(column) + 1;
            me._adjust(toIndex + 1 - base, fromIndex - 1 - base, 1);
        } else {
            setFromTo = to.get(column);
            me._adjust(fromIndex + 1 - base, toIndex - base, -1);
        }

        this._setReorderPosition(from, setFromTo);
        me._changed();
    },

    //Adjust "column" for everything in [start,end] by amount
    _adjust: function(start, end, amount) {
        var me = this,
            column = me.rowsReorderable,
            row;
        for (var i = start; i <= end; i++) {
            row = me._getRowFromIndex(i);
            this._setReorderPosition(row, row.get(column) + amount);
        }
    },

    _setReorderPosition: function(row, to) {
        const column = this.rowsReorderable;
        if(this.options.changeOnReorder) {
            const stopRefresh = e => e.preventDefault();
            this.bind("considerRefresh", stopRefresh);
            row.set(column, to);
            this.unbind("considerRefresh", stopRefresh);
        } else {
            row[column] = to;
        }
    },

    //The built-in datasource indexOf method returns based on original data
    //This function returns the index of a row based off of its current position in table
    _getRowFromIndex: function(index) {
        var me = this;
        var tr = me.tbody.find("tr").get(index);
        return me.dataItem(tr);
    },

    //Gets the index given a tr
    _getIndexFromTR: function(tr) {
        var me = this;
        return me.tbody.find("tr").index(tr);
    },

    _changed: function() {
        var me = this,
            column = me.rowsReorderable;

        me._prepareRowsReorderable();
        //determine if datasource is local or remote sorting
        //don't trigger a remote sort
        //but if it can be handled locally, get the datasource fixed up
        if (!me.dataSource.options.serverSorting) {
            me.dataSource.sort({
                field: column,
                dir: "asc"
            });
        }
        me.trigger("reorder");
    },

    _preRefreshReorderable: function() {
        if (this.rowsReorderable) {
            this.tbody.find(".DFGridDragButton")
                .off();
        }
    },

    /**
     * Makes all the rows in the tbody re-orderable based on the given column
     * @private
     */
    _makeRowsReorderable: function() {

        if (!this.rowsReorderable) {
            return;
        }

        this.tbody.find(".DFGridDragButton")
            .attr("tabindex", "-1")
            .attr("alt", locale.get("reorder"))
            .attr("title", locale.get("reorder"))
            .click(function(e) {
                e.preventDefault();
            });
        this._sortableWidget = new kendo.ui.Sortable(this.element, {
            filter: "tr[data-uid]",
            cursor: "move",
            axis: "y",
            autoScroll: true,
            handler: ".DFGridDragButton, .DFGridDragButton *",
            ignore: ":not(.DFGridDragButton):not(.DFGridDragButton *)",
            placeholder: function(row) {
                return row.clone().removeAttr("id").addClass("placeholderBox");
            },
            start: (e) => {
                if(this.options.disableReorderable) {
                    e.preventDefault();
                }
            },
            change: (e) => {
                this._haltRefresh = true;
                reorder(this.dataSource, e.oldIndex, e.newIndex, this.rowsReorderable, this.options.reorderableRowsBase, undefined, true);
                this._haltRefresh = false;
                this._changed();
            }
        });
    },

    _readonlyReorderable: function() {
        if (this.rowsReorderable) {
            if (this.options.readonly) {
                this.hideColumn(0);
            } else {
                this.showColumn(0);
            }
        }
    }

}
